import { instance } from '../instance'

/**
 * Update information about wallet
 *
 * @param {string} id - The unique identifier (UUID) of the wallet.

 * @param {Object} data - An object containing the data fields that should be updated in the wallet. This object can include:
 *   @property {string} [description] - A textual description for the wallet. This field is optional.
 *   @property {string} [color] - A string representing the color associated with the wallet label. This is typically in a HEX format (e.g., "#FF5733"). This field is optional.
 *   @property {number} [isVisible] - An integer flag (0 or 1) indicating whether the wallet should be visible (1) or hidden (0). This field is optional.

 * @param {number|boolean} [validate=0] - An optional parameter that indicates whether the server should validate the request data.
 * @return {Promise<AxiosResponse<any>>}
 */
export const update = (id, data, validate) => {
  return instance.patch(`/v3/wallet/${id}`, data, {
    params: {
      validate: Number(validate),
    },
  })
}
